module.exports = __webpack_public_path__ + "img/mision.e482a81c.png";